import React from 'react'
import styled from 'styled-components'
import ReactPlayerLoader from '@brightcove/react-player-loader';

const MainWrapper = styled.div`
  width: 100%;
  margin: 10px auto;
`
const HomeHeader = styled.h1`
    font-weight: 500;
    width: 70%;
    margin: 0 auto 53pt !important;
    text-align: center;
    font-size: 20pt;
    display: block;

    @media screen and (min-width: 768px) {
      margin-bottom: 3rem !important;
    }
  `

const WrapperDiv = styled.section`
  margin: auto;
  width: 90%;
  max-width: 880px;
  position: relative; 
  display: flex;
  justify-content: center;
  padding-top: 56.25%;

  .brightcove-react-player-loader {    
    position: absolute;
    top: 0px; 
    right: 0px;
    bottom: 0px;
    left: 0px;
    width: 100%;
    height: 100%; 
  }

  .bc-player-default_default {
    width: 100%;
    height: 100%;
  }
  `

const Video = ({ accountId, videoId, videoName }) => {
  return (
    <MainWrapper>
      <HomeHeader>{videoName}</HomeHeader>
      <WrapperDiv>
        <div>
          <ReactPlayerLoader accountId={accountId} videoId={videoId} />
        </div>
      </WrapperDiv>
    </MainWrapper>

  )
}

export default Video

